import { URLS, getAPIEndPoint } from "../consts/APIEndpoints";
import { getResponse } from "../utils/common";

export async function getCcmConfig() {
  return getResponse(`${getAPIEndPoint(URLS.CCM_API)}`, "get", undefined);
}
